class ProductForm extends HTMLElement {
  constructor() {
    super();

    // Check if we have extra options on the HTML
    this.options = {
      isBundle: false,
    };

    if (this && this.dataset && this.dataset.options) {
      const jsonOptions = JSON.parse(this.dataset.options);

      if (jsonOptions) {
        this.options = {
          ...this.options,
          ...jsonOptions,
        };
      }
    }

    this.form = this.querySelector('form');
    this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    this.formTrigger = this.form.querySelector('button[type="submit"]');

    this.cartNotification = document.querySelector('cart-notification');
    this.cartDrawer = document.querySelector('cart-drawer');
    this.cartItems = document.querySelector('cart-items');

    this.sectionsToFetch = [];

    // Be aware you only fetch a maximum of 5 sections! Otherwise it will return null.
    if (document.body.classList.contains('template-cart')) {
      if (this.cartItems) {
        this.sectionsToFetch = [...this.cartItems.getSectionsToRender().map((section) => section.section)];
      }
    } else {
      if (this.cartDrawer) {
        this.sectionsToFetch = [
          ...this.sectionsToFetch,
          ...this.cartDrawer.getSectionsToRender().map((section) => section.id),
        ];
      }
      if (this.cartNotification) {
        this.sectionsToFetch = [
          ...this.sectionsToFetch,
          ...this.cartNotification.getSectionsToRender().map((section) => section.id),
        ];
      }
    }
  }

  async onSubmitHandler(evt) {
    evt.preventDefault();

    const submitButton = this.querySelector('[type="submit"]');
    if (!submitButton.dataset.addToCartBehavior) return;

    submitButton.setAttribute('disabled', true);
    submitButton.classList.add('loading');

    const formData = new FormData(this.form);
    let parsedState2,
      lowestInventoryForBundle = this.options.bundleInventory || +formData.get('inventory_quantity');

    // Add default form properties
    let defaultProperties = {};
    for (const entry of formData.entries()) {
      if (entry[0].includes('properties')) {
        let propertyKey = entry[0].match(/\[(.*?)\]/)[1];
        defaultProperties[propertyKey] = entry[1];
      }
    }

    // default object
    let items = [
      {
        id: +formData.get('id'),
        quantity: 1,
        properties: defaultProperties,
      },
    ];

    // when this is a bundle, add all bundle items to the object as well, the main bundle product is removed after successful add
    if (this.options.isBundle) {
      for await (const id of this.options.bundleProducts) {
        items.push({
          id,
          quantity: +formData.get('quantity'),
          properties: {
            _bundle: this.options.productHandle,
            _bundleId: this.options.productId,
            bundleName: this.options.bundleName,
            ...defaultProperties,
          },
        });
      }
    }
    const body = JSON.stringify({
      ...{ items },
      sections: this.sectionsToFetch,
      sections_url: window.location.pathname,
    });

    try {
      const response = await fetch(`${routes.cart_add_url}.js`, {
        ...fetchConfig(),
        ...{ body },
      });

      if (response.status === 422) {
        // When quantity error (this will not fire for bundles since that quantity is based on the available SKU's)
        this.cartNotification.setActiveElement(document.activeElement);
        this.cartNotification.renderQuantityError(lowestInventoryForBundle, this.formTrigger);
        return;
      } else if (!response.ok) throw new Error(response.status);

      // On success:
      const parsedState = await response.json();

      // if this is a bundle with separate SKU's, we need to remove the parent product from the cart. We do this afterwards, because we need to display the cart notification with the bundle product
      if (this.options.isBundle) {
        // remove the bundle item again from the cart
        const body = JSON.stringify({
          id: parsedState.items[0].key,
          quantity: 0,
          sections: this.sectionsToFetch,
        });

        try {
          const response = await fetch(`${routes.cart_change_url}.js`, {
            ...fetchConfig(),
            ...{ body },
          });
          if (!response.ok) throw new Error(response.status);

          // On success:
          parsedState2 = await response.json();

          // update the cart drawer
          this.cartDrawer?.renderContents(parsedState2);
        } catch (error) {
          debug() && console.log('Error removing the bundle from the cart', error);
        }
      } else {
        // always update the cart drawer
        this.cartDrawer?.renderContents(parsedState);
      }

      // for the cart notification, we pass both parsed states, since the first one contains the actual bundle and that information, and the second contains the actual cart totals
      switch (submitButton.dataset.addToCartBehavior) {
      case 'update_cart':
        this.cartItems?.renderContents(parsedState);
        break;
      case 'show_cart_notification':
        this.cartNotification.setActiveElement(document.activeElement);
        this.cartNotification.renderContents(
          parsedState,
          this.closest('[data-product-info]'),
          this.formTrigger,
          this.options.isBundle,
          parsedState2,
        );
      }

      // Send Tealium event
      if (window.tealium.useTealium) {
        const addedProducts = parsedState.items;
        tealiumAddProducts({
          product_id: addedProducts.map((product) => product.sku),
          product_name: addedProducts.map((product) => product.title),
          product_price: addedProducts.map((product) => product.price),
          product_brand: addedProducts.map((product) => product.vendor),
          product_quantity: addedProducts.map((product) => product.quantity),
        });
      }
    } catch (error) {
      debug() && console.log('Error adding to cart', error);
    } finally {
      submitButton.classList.remove('loading');
      submitButton.removeAttribute('disabled');
    }
  }
}
if (!customElements.get('product-form')) {
  customElements.define('product-form', ProductForm);
}
